import ModalWrapper from './ModalWrapper';
import { ExportedModalProps, ModalWrapperProps } from './types';

export type { ExportedModalProps, ModalWrapperProps };
export default ModalWrapper;
